import { createBlock, mergeBlock, t } from "@easy-email-pro-core/utils";

import { BasicType, ElementCategory } from "@easy-email-pro-core/constants";
import {
  PlaceholderElement,
  ElementDefinition,
} from "@easy-email-pro-core/typings";
import React from "react";
import { BasicBlock } from "@easy-email-pro-core/components";

const defaultData: ElementDefinition<PlaceholderElement>["defaultData"] = {
  attributes: {},
  data: {},
};

export const Placeholder = createBlock<PlaceholderElement>({
  get name() {
    return t("Placeholder");
  },
  defaultData,
  type: BasicType.PLACEHOLDER,
  create: (payload) => {
    const defaultData: PlaceholderElement = {
      type: BasicType.PLACEHOLDER,
      data: {},
      attributes: {},
      children: [{ text: "" }],
    };
    return mergeBlock(defaultData, payload);
  },
  category: ElementCategory.UNSET,
  render(params) {
    if (params.mode === "production") {
      return null;
    }

    return (
      <BasicBlock
        tag={"span"}
        params={{
          ...params,
          node: {
            ...params.node,
            attributes: {
              "element-type": BasicType.PLACEHOLDER,
              "element-category": ElementCategory.UNSET,
            } as any,
          },
        }}
      />
    );
  },
});
